import React from 'react';
import LectureManagementComponent from '../../../components/admin/class/LectureManagementComponent';

const LectureManagement: React.FC = () => {
  return <LectureManagementComponent />;
};

export default LectureManagement;
